import {$api} from "../../api";
import {AxiosResponse} from "axios";

interface IBody {
    addressId:number|null,
    date:string
}
export class ReconciliationService {
    static async fetchReconciliationExcel({addressId,date}:IBody): Promise<AxiosResponse<any>> {
        return $api.get<any>(`api/adm/total-reconciliations/${addressId}/month/${date}/export`)
    }
}
